import { render, staticRenderFns } from "./BFStep3BillingCard.vue?vue&type=template&id=afbc3ae8"
import script from "./BFStep3BillingCard.vue?vue&type=script&lang=js"
export * from "./BFStep3BillingCard.vue?vue&type=script&lang=js"
import style0 from "./BFStep3BillingCard.vue?vue&type=style&index=0&id=afbc3ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports